import { useResolvedLocale } from '../../lib/hooks/locale.ts';

type Props = {
    children: number;
};

export function FileSize({ children }: Props) {
    const locale = useResolvedLocale();

    const { value, unit } =
        children < 1000
            ? { value: children, unit: 'byte' as const }
            : children < 1000 * 1000
              ? { value: children / 1000, unit: 'kilobyte' as const }
              : { value: children / (1000 * 1000), unit: 'megabyte' as const };

    const formatted = new Intl.NumberFormat(locale, {
        style: 'unit',
        unit,
        unitDisplay: 'short',
        maximumFractionDigits: unit === 'byte' ? 0 : 1,
    }).format(value);

    return <>{formatted}</>;
}
